import signalTrackerListener from 'listeners/lib/signalTrackerListener';
import { action } from 'satcheljs/lib/legacy';
import { datapointMiddleware } from 'middlewares';
import { initializeLogger } from 'bootstrap';
import { lazyRegisterMailWorkflowConfigs } from 'workflow-configs';
import { logListener } from 'listeners';
import { MAILLIST_RENDERED } from 'mini-mail-common/lib/utils/eventSignalConstants';
import { registerA2HSEventListeners } from 'mini-a2hs';
import { registerListener, registerMiddleware } from 'mini-app-context';
import { trackLargestSurfaceRender } from 'bootstrap/lib/trackLargestSurfaceRender';

/**
 * Function which runs initial setup before bootstrap begins.
 */
export default action('initialMailSetup')(function initialMailSetup(): void {
    initializeLogger();
    registerMiddleware(datapointMiddleware);

    registerListener(logListener);
    registerListener(signalTrackerListener);

    trackLargestSurfaceRender([MAILLIST_RENDERED]);

    // lazy register all workflow configs for mail module
    lazyRegisterMailWorkflowConfigs.importAndExecute();

    registerA2HSEventListeners();
});
